import { Component } from '@inter-ikea-core/core';

/**
 * Component added to fronts that has more than one handle
 */
export default class MultiHandleComponent implements Component {
  static id = 2060;
  typeId = MultiHandleComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;
  nbrOfHandles: number;

  constructor(nbrOfHandles: number) {
    this.nbrOfHandles = nbrOfHandles;
  }

  eq(other: MultiHandleComponent) {
    return this.nbrOfHandles === other.nbrOfHandles;
  }
}
